var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormContext, useFormState } from 'react-hook-form';
import { FormControl, FormLabel, FormTextarea } from 'shared/components';
export var InteractionSummary = function () {
    var register = useFormContext().register;
    var errors = useFormState().errors;
    return (_jsxs(FormControl, __assign({ mt: 4, isRequired: true }, { children: [_jsx(FormLabel, __assign({ htmlFor: "interactionSummary" }, { children: "Interaction Summary" })), _jsx(FormTextarea, { "data-testid": "interactionSummary", name: "interactionSummary", rules: {
                    required: 'You must enter a summary of this interaction.',
                    maxLength: { value: 10000, message: 'The max length is 10,000 characters' },
                }, displayErrors: true, register: register, errors: errors })] })));
};
